import * as fetchOrder from 'store/actions/orders/fetchOrders';
import * as types from 'store/actions/types';
import * as updateOrders from 'store/actions/orders/updateOrders';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { fetchReceiptFailure, fetchReceiptSuccess, recentAlteration, retryOrderFailure, retryOrderSuccess } from 'store/actions/orderActions';
import { loaderOn, loaderOff } from 'store/actions/loaderActions';
import { push } from 'react-router-redux';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* orderCancelSuccess() {
    yield put(showNotification('notifications.orders.cancelled.success'));
}

function* orderCancelFailure({ error }) {
    yield put(showNotification(error, 'warning'));
}

function* orderResendEmailSuccess() {
    yield put(showNotification('resource.orders.actions.order_email_resent'));
    yield put(push('/orders'));
}

function* orderResendEmailFailure({ error }) {
    yield put(showNotification(error, 'warning'));
    yield put(push('/orders'));
}

function* fetchOrderAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ payload.id }`;

        const response = yield apiClient.read(url);

        yield put(fetchOrder.fetchOrderSuccess(response));
    } catch (error) {
        yield put(fetchOrder.fetchOrderFailure(error));
    }
}

function* updateOrderAsync({ payload }) {
    const { values } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ values.id }`;

        const response = yield apiClient.update(url, values);

        yield put(updateOrders.updateOrderSuccess(values.id, response));
    } catch (error) {
        // Trigger the error action.
        yield put(updateOrders.updateOrderFailure(error));
    }

    yield payload.callback();
}

function* amendOrderAsync({ payload }) {
    const { id, values } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/amend`;

        const response = yield apiClient.update(url, values);

        yield put(updateOrders.amendOrderSuccess(id, response));
    } catch (error) {
        // Trigger the error action.
        yield put(updateOrders.amendOrderFailure(error));
    }

    yield payload.callback();
}

function* updateOrderSuccessAsync({ id }) {
    yield put(recentAlteration(id, true));

    yield put(push(`/orders/${ id }/show`));

    yield put(showNotification('notifications.orders.update.success'));
}

function* fetchReceiptAsync({ id }) {
    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/receipt`;

        const response = yield apiClient.read(url);

        yield put(fetchReceiptSuccess({
            response: response,
            id: id,
        }));
    } catch (error) {
        yield put(fetchReceiptFailure(error, id));
    }
}

function* fetchReceiptFailureAsync({ error }) {
    yield put(showNotification(error, 'warning'));
}

function* retryOrderRequestAsync({ payload }) {
    const { id } = payload;

    yield put(loaderOn());

    try {
        const url = yield `${ config.getApiBaseUrl() }/bookings/${ id }/retry`;

        const response = yield apiClient.create(url);

        yield put(retryOrderSuccess({
            response: response,
            payload: id,
        }));

        yield put(loaderOff());
    } catch (error) {
        yield put(retryOrderFailure(error, id));

        yield put(loaderOff());
    }
}

function* retryOrderFailureAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

function* retryOrderSuccessAsync() {
    yield put(showNotification('notifications.orders.retry.success', 'success'));
}

function* voucherOrderFailureAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

function* voucherOrderSuccessAsync({ message }) {
    yield put(showNotification(message, 'success'));
}

function* failureMessage({ error }) {
    const { code, message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));

    if (code === 404) {
        yield put(push('/orders'));
    }
}

export default function* orderSagas() {
    yield [
        takeEvery(types.FETCH_ORDER, fetchOrderAsync),
        takeEvery(types.FETCH_ORDER_FAILURE, failureMessage),

        takeEvery(types.UPDATE_ORDER, updateOrderAsync),
        takeEvery(types.UPDATE_ORDER_FAILURE, failureMessage),
        takeEvery(types.UPDATE_ORDER_SUCCESS, updateOrderSuccessAsync),

        takeEvery(types.AMEND_ORDER, amendOrderAsync),
        takeEvery(types.AMEND_ORDER_FAILURE, failureMessage),
        takeEvery(types.AMEND_ORDER_SUCCESS, updateOrderSuccessAsync),

        takeEvery('ORDER_CANCEL_SUCCESS', orderCancelSuccess),
        takeEvery('ORDER_CANCEL_FAILURE', orderCancelFailure),
        takeEvery('ORDER_RESEND_EMAIL_SUCCESS', orderResendEmailSuccess),
        takeEvery('ORDER_RESEND_EMAIL_FAILURE', orderResendEmailFailure),

        takeEvery(types.FETCH_ORDER_RECEIPT, fetchReceiptAsync),
        takeEvery(types.FETCH_ORDER_RECEIPT_FAILURE, fetchReceiptFailureAsync),

        takeEvery(types.RETRY_ORDER_REQUEST, retryOrderRequestAsync),
        takeEvery(types.RETRY_ORDER_FAILURE, retryOrderFailureAsync),
        takeEvery(types.RETRY_ORDER_SUCCESS, retryOrderSuccessAsync),

        takeEvery(types.VOUCHER_ORDER_FAILURE, voucherOrderFailureAsync),
        takeEvery(types.VOUCHER_ORDER_SUCCESS, voucherOrderSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/orderSagas.js